import { Builder } from '@builder.io/sdk';
import { S3HowSection } from '../components/interactive-sections/S3How';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { 
    buttonVariantOptions, 
    textColorOptionsLimited,
    backgroundGradientOptions 
} from '../utils/builderColorOptions';
import { getBackgroundGradientInput, getPaddingInputs, getBackgroundColorInput } from '../utils/builderSharedInputs';


Builder.registerComponent(S3HowSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S3How,
    friendlyName: 'S3 How',
    inputs: [
        {
            name: 'headlineText',
            type: 'string',
            friendlyName: 'Headline',
            required: true,
            defaultValue: 'Experience the Future of Laser Hair Removal',
            helperText: 'The main heading displayed at the top of the section'
        },
        {
            name: 'headlineColor',
            type: 'string',
            friendlyName: 'Headline Color',
            enum: textColorOptionsLimited,
            defaultValue: 'Blue',
            helperText: 'Select a color for the headline text'
        },
        {
            name: 'text1',
            type: 'string',
            friendlyName: 'Text 1',
            required: true,
            defaultValue: 'Our advanced laser technology provides precise, long-lasting results with minimal discomfort. Discover how our innovative approach is revolutionizing hair removal treatments.',
            helperText: 'Supporting first text content below the headline. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}'
        },
        {
            name: 'text2',
            type: 'string',
            friendlyName: 'Text 2',
            defaultValue: 'Are you a good candidate for laser hair removal? Answer 5 quick questions to help determine if you qualify.',
            helperText: 'Supporting second text content below the headline. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}'
        },
        {
            name: 'textColor',
            type: 'string',
            friendlyName: 'Text Color',
            enum: textColorOptionsLimited,
            defaultValue: 'Navy',
            helperText: 'Select a color for the main text content'
        },
        {
            name: 'textHorizontalPosition',
            type: 'boolean',
            friendlyName: 'Image Display Side (Desktop)',
            defaultValue: false,
            helperText: 'Toggle image position from right to left (Desktop display)',
        },
        {
            name: 'textVerticalPosition',
            type: 'boolean',
            friendlyName: 'Image Display Location (Tablet/Mobile)',
            defaultValue: false,
            helperText: 'Toggle image position from bottom to top (Tablet/Mobile displays)',
        },
       
        {
            name: 'images',
            type: 'list',
            friendlyName: 'Section Images',
            required: true,
            helperText: 'Add up to 4 images for the section (maximum 4 images allowed)',
            defaultValue: [
                { image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F67b1fa3589bb4d7b857cf677a7cdd8c2' },
                { image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F4a8347c68f10415483232ad56e78526a' },
                { image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fd34ad52bb4c646a6997d8b5cf937ccc1' },
                { image: 'https://cdn.builder.io/api/v1/image/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F43b40c39d513468da4aa0d622573ec80' }
            ],
            onChange: (options) => {
                // Check if the list has more than 4 items
                if (options.get('images').length > 4) {
                  options.set('images', options.get('images').slice(0, 4))
                  alert('maximum items are 4, delete items to continue')
                }
                // check if the list has less than 4 items
                if (options.get('images').length < 4) {
                    alert('minimum items are 4, add items to continue')
                }
            },
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
                    friendlyName: 'Image',
                    helperText: 'Upload an image for the section',
                },
                {
                    name: 'imageAltText',
                    type: 'string',
                    friendlyName: 'Image Alt Text',
                    required: true,
                    helperText: 'Alt text for the image',
                },
            ]
        },
        {
            name: 'buttons',
            type: 'list',
            friendlyName: 'Buttons',
            helperText: 'Add a call-to-action button that will appear below the section text (maximum 1 button allowed)',
            onChange: (options) => {
                const items = options.get('buttons');
                if (items.length > 1) {
                    options.set('buttons', items.slice(0, 1));
                    alert('Maximum 1 button allowed');
                }
            },
            subFields: [
                {
                    name: 'label',
                    type: 'string',
                    required: true,
                    friendlyName: 'Button Text',
                    helperText: 'The text that will appear on the button (keep it short and action-oriented)',
                    defaultValue: 'Learn More'
                },
                {
                    name: 'variant',
                    type: 'string',
                    required: true,
                    friendlyName: 'Button Variant',
                    enum: buttonVariantOptions,
                    helperText: 'The style of the button: primary (blue), secondary (navy blue - darker than primary), cta (special emphasis)',
                    defaultValue: 'primary'
                },
                {
                    name: 'url',
                    type: 'string',
                    required: true,
                    friendlyName: 'Button URL',
                    helperText: 'The destination page when the button is clicked (e.g., /services, /contact, /special-offer)',
                    defaultValue: '/process'
                }
            ]
        },
        ...getBackgroundColorInput({
            defaultValue: 'White',
        }),
        ...getBackgroundGradientInput({
            backgroundGradientList: backgroundGradientOptions  
        }),
        {
            name: 'backgroundImage',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
            friendlyName: 'Background Image',
            helperText: 'Upload an image to use as the section background'
        },
        ...getPaddingInputs({
            desktopTop: "small",
            desktopBottom: "small",
            mobileTop: "small",
            mobileBottom: "small"
        })
    ]
});